import React, { useState } from "react"

import Link from '../../utils/link'

import { FaCaretLeft, FaCaretRight } from "react-icons/fa"

import "./Slider.scss"

const Slider = (props) => {
  
  const [x, setX] = useState(0)

  const previousSlide = () => {
    x === 0 ? setX(-100 * (props.rooms.length - 1)) : setX(x + 100)
  }

  const nextSlide = () => {
    x === -100 * (props.rooms.length - 1) ? setX(0) : setX(x - 100)
  }

  return (
    <section className="slider-section">
      <div className="slider-section__container">
        {props.rooms.map((item, index) => {
          return (
            <div
              key={index}
              className="slider-section__container__slide"
              style={{ transform: `translateX(${x}%)` }}
            >
              <Link to={`/room/${item.slug}`} className="image__container">
                <img src={item.acf.card.image.localFile.childImageSharp.fluid.src} />
                <div className="image__container__heading">
                  {item.acf.card.title}
                </div>
                <div className="image__container__sub-heading">
                  {item.acf.card.bedrooms} {item.acf.card.bedrooms > 1 ? 'Bedrooms' : 'Bedroom'} - Sleeps {item.acf.card.sleeps}
                </div>
              </Link>
            </div>
          )
        })}
        <button
          className="slider-section__container__slide__left"
          onClick={previousSlide}
        >
          <FaCaretLeft />
        </button>
        <button
          className="slider-section__container__slide__right"
          onClick={nextSlide}
        >
          <FaCaretRight />
        </button>
      </div>
    </section>
  )
}

export default Slider
